/* HomePlunge AU gate.
   Australia is served by our distributor. AU shipping rates were removed from
   the Fulfill Plus delivery profile, so an AU checkout has no rate and cannot
   complete. This script makes that intentional: it swaps every buy control for
   a link to the partner and routes cart and checkout entry points to
   /pages/australia rather than letting anyone hit an empty rate list.

   Detection order:
     1. window.HP_AU, set server-side by snippets/hp-au-gate.liquid from
        localization.country.iso_code. Shopify varies its page cache by market,
        so this is correct on a cached response.
     2. Shopify.country, the same signal read from content_for_header. Belt and
        braces for any response that slipped through with the wrong market.
     3. ?hp_au=1 in the URL, for testing from outside Australia. Persisted for
        the session so navigation keeps the state. ?hp_au=0 clears it. */
(function () {
  'use strict';

  var PARTNER = 'https://www.homeplunge.com.au/';
  var UTM = '?utm_source=thehomeplunge&utm_medium=referral&utm_campaign=au_gate';
  var INFO_PAGE = '/pages/australia';
  var TEST_KEY = 'hp-au-test';
  var BAR_KEY = 'hp-au-bar-dismissed';

  function testFlag() {
    try {
      var q = new URLSearchParams(window.location.search);
      if (q.get('hp_au') === '1') { sessionStorage.setItem(TEST_KEY, '1'); return true; }
      if (q.get('hp_au') === '0') { sessionStorage.removeItem(TEST_KEY); return false; }
      return sessionStorage.getItem(TEST_KEY) === '1';
    } catch (e) { return false; }
  }

  function isAU() {
    if (window.HP_AU === true) return true;
    try { if (window.Shopify && window.Shopify.country === 'AU') return true; } catch (e) {}
    return testFlag();
  }

  if (!isAU()) return;

  var root = document.documentElement;
  root.classList.add('hp-au');

  function partnerHref(campaign) {
    return PARTNER + UTM + (campaign ? '_' + campaign : '');
  }

  /* Build the replacement CTA. `variant` is 'mobile' for the sticky bar. */
  function buildCta(variant, campaign) {
    var wrap = document.createElement('div');
    wrap.className = 'hpau-buy' + (variant === 'mobile' ? ' hpau-buy--mobile' : '');
    wrap.setAttribute('data-hpau-cta', '1');

    var a = document.createElement('a');
    a.className = 'hpau-buy__btn';
    a.href = partnerHref(campaign);
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Buy in Australia';
    wrap.appendChild(a);

    if (variant !== 'mobile') {
      var p = document.createElement('p');
      p.className = 'hpau-buy__note';
      p.innerHTML = 'We do not ship to Australia from the United States. ' +
        'HomePlunge is sold and supported here by our Australian partner. ' +
        '<a href="' + INFO_PAGE + '">Why, and what that means</a>';
      wrap.appendChild(p);
    }
    return wrap;
  }

  /* Place one CTA next to each hidden buy control, in the same slot so it keeps
     the visual position the button had. Guarded so repeated runs are harmless. */
  function placeCtas() {
    var anchors = [
      { sel: '#hpp-add-to-cart', variant: 'full', campaign: 'pdp' },
      { sel: '.hpp-add-to-cart', variant: 'full', campaign: 'pdp' },
      { sel: '.product-form__submit', variant: 'full', campaign: 'pdp' },
      { sel: '.hpp-mobile-cta__cta', variant: 'mobile', campaign: 'sticky' },
      { sel: 'button[name="add"]', variant: 'full', campaign: 'pdp' },
      { sel: 'button[name="checkout"]', variant: 'full', campaign: 'cart' },
      { sel: '.cart__checkout-button', variant: 'full', campaign: 'cart' },
      { sel: '.cart-drawer__checkout', variant: 'full', campaign: 'cart' },
      { sel: '.cp-checkout-btn', variant: 'full', campaign: 'cartsummary' },
      { sel: '.cd-checkout', variant: 'full', campaign: 'drawer' }
    ];

    anchors.forEach(function (a) {
      var nodes = document.querySelectorAll(a.sel);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset.hpauSwapped) continue;
        el.dataset.hpauSwapped = '1';
        var parent = el.parentNode;
        if (!parent) continue;
        // Skip if a sibling CTA is already sitting here.
        if (parent.querySelector(':scope > [data-hpau-cta]')) continue;
        parent.insertBefore(buildCta(a.variant, a.campaign), el.nextSibling);
      }
    });
  }

  /* Stop the add-to-cart form from ever submitting. */
  function guardForms() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && f.action.indexOf('/cart/add') !== -1) {
        e.preventDefault();
        e.stopPropagation();
        window.open(partnerHref('form'), '_blank', 'noopener');
      }
    }, true);
  }

  /* Route cart and checkout entry points to the explainer page instead of a
     checkout that has no shipping rate. */
  function guardLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (/^\/(cart|checkout)(\/|$|\?)/.test(href) || href.indexOf('/checkouts/') !== -1) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = INFO_PAGE;
      }
    }, true);
  }

  /* On the cart page itself, say what is going on above the line items. */
  function cartNotice() {
    if (!/^\/cart/.test(window.location.pathname)) return;
    if (document.querySelector('[data-hpau-cart]')) return;
    var host = document.querySelector('#MainContent') || document.body;
    var box = document.createElement('div');
    box.className = 'hpau-cart';
    box.setAttribute('data-hpau-cart', '1');
    box.innerHTML =
      '<p>We do not ship to Australia from the United States. HomePlunge is sold ' +
      'and supported in Australia by our partner, who holds stock locally and ' +
      'handles delivery and service.</p>';
    var a = document.createElement('a');
    a.className = 'hpau-buy__btn';
    a.href = partnerHref('cartpage');
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Buy in Australia';
    box.appendChild(a);
    host.insertBefore(box, host.firstChild);
  }

  /* The notice bar dismiss only hides the bar. The buy controls stay swapped. */
  function wireBar() {
    var bar = document.querySelector('.hpaubar');
    if (!bar) return;
    var dismissed = false;
    try { dismissed = localStorage.getItem(BAR_KEY) === '1'; } catch (e) {}
    if (dismissed) { bar.hidden = true; return; }
    bar.hidden = false;
    var x = bar.querySelector('.hpaubar__x');
    if (x) {
      x.addEventListener('click', function () {
        bar.hidden = true;
        try { localStorage.setItem(BAR_KEY, '1'); } catch (e) {}
      });
    }
  }

  function run() {
    placeCtas();
    cartNotice();
    wireBar();
  }

  guardForms();
  guardLinks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The cart drawer and the sticky mobile bar mount late, and the drawer
     re-renders on every cart change, so re-run on mutations. Throttled to one
     pass per frame. */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('load', run);
})();
